/*
 * 4mypet installation variant map.
 * Auto-generated from Shopify product data:
 *   Installation - 1 Man  (product ID: 15747628925302)
 *   Installation - 2 Man  (product ID: 15747685810550)
 * Generated: 2026-08-17
 */

window.FMP_INSTALL_VARIANTS = {
  "1man": {
    "335": 57926697353590,
    "345": 58473685844342,
    "346": 58473685877110,
    "355": 58473685909878,
    "360": 58473685942646,
    "364": 58473685975414,
    "370": 58473686008182,
    "375": 58473686040950,
    "385": 58473686073718,
    "395": 58473686106486,
    "399": 58473686139254,
    "400": 58473686172022,
    "410": 58473686204790,
    "415": 58473686237558,
    "425": 58473686270326,
  },
  "2man": {
    "435": 57927510425974,
    "445": 58473686303094,
    "446": 58473686335862,
    "455": 58473686368630,
    "460": 58473686401398,
    "465": 58473686434166,
    "470": 58473686466934,
    "475": 58473686499702,
    "485": 58473686532470,
    "495": 58473686565238,
    "496": 58473686598006,
    "499": 58473686630774,
    "500": 58473686663542,
    "510": 58473686696310,
    "515": 58473686729078,
    "525": 58473686761846,
    "540": 58473686794614,
    "545": 58473686827382,
  },
};
